import React from "react";
import FindingDistribution from './Dashboard/FindingDistribution';
import AchievementPercentage from './Dashboard/AchievementPercentage';
import {
  Container,
  Row,
  Col,
} from "react-bootstrap";

function Dashboard() {



  return (
    <Container fluid>
      <Row>
        <Col md="12">
          <FindingDistribution />
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <AchievementPercentage />
        </Col>
      </Row>
    </Container>
  );
}

export default Dashboard;
